export const BRANDS_TAG = 'brand'

export const serviceStaffSelectionMode = {
    ASSIGNED_STAFF: 'AssignedStaff',
    OPTIONAL_ASSIGNED_STAFF: 'OptionalAssignedStaff'
}
